var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/chair"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.57143 18.6087H18.4286M5.57143 18.6087C4.15127 18.6087 3 17.4575 3 16.0373V10.2516C3 9.18648 3.86345 8.32303 4.92857 8.32303C5.15398 8.32303 5.37036 8.36171 5.57143 8.43277M5.57143 18.6087V21.1802M18.4286 18.6087C19.8488 18.6087 21 17.4575 21 16.0373V10.2516C21 9.18648 20.1365 8.32303 19.0714 8.32303C18.846 8.32303 18.6297 8.36171 18.4286 8.43277M18.4286 18.6087V21.1802M5.57143 8.43277C6.32049 8.69752 6.85714 9.41189 6.85714 10.2516V13.4659H17.1429V10.2516C17.1429 9.41189 17.6795 8.69752 18.4286 8.43277M5.57143 8.43277V8.32303C5.57143 5.48271 7.87396 3.18018 10.7143 3.18018H13.2857C16.126 3.18018 18.4286 5.48271 18.4286 8.32303V8.43277",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingPerformance);
export default __webpack_public_path__ + "static/media/bookingPerformance.94273fd1abe6d54009d8151633807ff1.svg";
export { ForwardRef as ReactComponent };